import React, { useEffect, useState } from 'react';
import {
  func,
  string,
  shape,
  arrayOf
} from 'prop-types';
import { SuperSkuAttribute } from '../super-sku-attribute/super-sku-attribute';
import { SuperSkuAttributeValue } from '../super-sku-attribute-value/super-sku-attribute-value';

// Add onClick and attributes props
export const CollectionsSuperSku = ({
  onChange,
  channel,
  attributes,
  collectionId: collectionIdProp
}) => {
  const [collection, setCollection] = useState({});

  const convertStrHyphenLowercase = (data) => {
    return data.replace(/\s+/g, '-').toLowerCase();
  };

  const findSelectedCollectionByName = (data) => {
    return attributes?.linkedCollections?.find((value) => value.name === data);
  };

  const findSelectedCollectionById = (data) => {
    return attributes?.linkedCollections?.find((value) => convertStrHyphenLowercase(value.id) === data);
  };

  useEffect(() => {
    if (collectionIdProp && collectionIdProp !== collection?.id) {
      setCollection(findSelectedCollectionById(collectionIdProp));
    }
  }, [collectionIdProp, collection]);

  const handleSuperSkuSelect = (event, attributeValue) => {
    const selectedAttribute = findSelectedCollectionByName(attributeValue);
    setCollection(selectedAttribute);
    onChange({ collectionIdValue: convertStrHyphenLowercase(selectedAttribute.id) });
  };

  if (attributes?.linkedCollections?.length === 0) {
    return null;
  }

  return (
    <SuperSkuAttribute
      attributeName={attributes?.title}
      attributeValue={collection?.name}
      attributeType="tile"
    >
      {
        attributes?.linkedCollections?.map((attributeValue) => {
          const isSelectedAttributeValue = attributeValue?.id === collection.id;
          return (
            <SuperSkuAttributeValue
              value={attributeValue.name}
              isAvailable
              key={attributeValue?.id}
              isSelected={isSelectedAttributeValue}
              attributeType="tile"
              onClick={(event) => handleSuperSkuSelect(
                event,
                attributeValue.name
              )}
              channel={channel}
            />
          );
        })
      }
    </SuperSkuAttribute>
  );
};

CollectionsSuperSku.propTypes = {
  onChange: func.isRequired,
  channel: string.isRequired,
  attributes: shape({
    title: string,
    linkedCollections: arrayOf(shape(
      {
        id: string,
        name: string,
        swatch: string
      }
    ))
  }).isRequired,
  collectionId: string.isRequired
};
